import { useMemo } from 'react';
import { css } from '@emotion/react';
import { useViewportWidth } from 'client/hooks/useViewportWidth';
import { Typography } from 'client/components/Typography';
import { breakPoint } from 'client/Theme';
import { BreadcrumbsItem, BreadcrumbsItemProps } from './BreadcrumbsItem';

const Seperator = () => (
  <Typography component="span" variant="caption" css={seperatorStyle}>
    /
  </Typography>
);

export interface BreadcrumbsProps {
  items: BreadcrumbsItemProps[];
}

export const Breadcrumbs = ({ items, ...other }: BreadcrumbsProps) => {
  const viewportWidth = useViewportWidth();

  const visibleItems = useMemo(() => {
    if (viewportWidth > breakPoint.medium) return items;
    return [{ title: '…' }, ...items.slice(1).slice(-2)];
  }, [viewportWidth, items]);

  return (
    <ol css={breadcrumbsStyle} {...other}>
      {visibleItems.map((item, index) => [
        index > 0 && <Seperator key={`${item.title}-${index}-s`} />,
        <BreadcrumbsItem key={`${item.title}-${index}`} {...item} />,
      ])}
    </ol>
  );
};

const breadcrumbsStyle = css`
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
`;

const seperatorStyle = css`
  margin: 0 10px;
  font-weight: bold;
  user-select: none;
  opacity: 0.5;
`;
